import { createFileRoute } from '@tanstack/react-router'
import { MigrationPage } from 'pages/migration/MigrationPage'

export const Route = createFileRoute('/migration')({
  component: RouteComponent,
  staticData: {
    title: 'Migration',
  },
})

function RouteComponent() {
  return (
    <>
      <MigrationPage />
    </>
  )
}
